import React from 'react';
import PropTypes from 'prop-types';

const ClearableInput = ({
  getRef,
  value,
  onClear,
  disableClear,
  ...rest
}) => (
  <div className="input-container">
    <input
      ref={getRef}
      {...rest}
      value={value}
    />
    { !disableClear && !!value && (
      <i
        className="clear fa fa-times-circle"
        onClick={onClear}
      />
    )}
  </div>
);

ClearableInput.defaultProps = {
  getRef: undefined,
  disableClear: false,
};

ClearableInput.propTypes = {
  /** Returns the component reference */
  getRef: PropTypes.any,
  /** Value to input */
  value: PropTypes.string.isRequired,
  /** Callback to be called when clicking on clean icon */
  onClear: PropTypes.func.isRequired,
  /** Disable clear option */
  disableClear: PropTypes.bool,
};

export default ClearableInput;
